import { useCurrentUser } from '@/user/use-current-user.query';
import { useMemo } from 'react';
import { useNotifications } from './use-notifications.query';

export const useHasUnreadNotifications = () => {
  const { data: user } = useCurrentUser();
  const { data: notifications } = useNotifications(user?.id ?? null);

  return useMemo(() => {
    if (!notifications || notifications.length === 0) {
      return false;
    }

    return notifications.some(notification => notification.readAt === null);
  }, [notifications]);
};
